//

import { SaveIcon } from 'modules/common/components/SvgIcon';

import S from './styles';

const Item = ({ title, value, linkTitle, onClick, 'data-testid': dataTestId }) => (
  <S.Wrapper>
    <S.Description>
      <S.Icon>
        <SaveIcon />
      </S.Icon>
      <span>{title}:</span>
      {value}
    </S.Description>
    {linkTitle && onClick && (
      <S.Link data-testid={dataTestId} type="link" onClick={onClick}>
        {linkTitle}
      </S.Link>
    )}
  </S.Wrapper>
);
Item.defaultProps = {
  linkTitle: undefined,
  onClick: undefined,
  value: undefined,
};

export default Item;
